<template>
  <div>
    <div class="d-flex mb-3 align-items-end">
      <h1 class="h4 primary--text">
        {{ $t('views.orders.nearest_shipment') }}
      </h1>
      <div class="ml-auto">
        <download-excel
          :url="`/order-reports/nearest-shipment-by-parts-xlsx`"
          file-name="nearest-shipment-by-parts.xlsx"
          :filters="filters"
          :params="params"
        />
        <v-btn
          outlined
          large
          @click="toggleFilters"
        >
          <v-icon left>
            mdi-filter-variant
          </v-icon>
          {{ $t('common.filter') }}
        </v-btn>
      </div>
    </div>
    <table-filters
      v-if="filtersShown"
      :filters="filters"
      @search="getItems(true)"
    />
    <v-data-table
      fixed-header
      :headers="headers"
      :items="items"
      :footer-props="{
        itemsPerPageOptions: [10, 20, 50, 100],
      }"
      :loading="loading"
      :loading-text="$t('common.loading_data')"
      :options.sync="options"
      :server-items-length="total"
    />
  </div>
</template>

<script>
import TableFilters from '@/components/common/TableFilters.vue';
import DownloadExcel from '@/components/common/DownloadExcel.vue';

export default {
  name: 'NearestShipment',
  components: {
    TableFilters,
    DownloadExcel,
  },
  props: {
    supplier: String,
    plant: String,
    part: String,
    date: String,
  },
  data() {
    return {
      total: 0,
      items: [],
      loading: false,
      noItemsFound: false,
      options: {
        page: 1,
      },
      headers: [],
      filtersShown: true,
      filters: [{
        label: this.$t('common.supplier'),
        key: 'supplier',
        value: '',
        requiredForSupplier: true,
      }, {
        label: this.$t('common.plant'),
        key: 'plant',
        value: '',
        requiredForSupplier: true,
      }, {
        label: this.$t('common.part'),
        key: 'part',
        value: '',
      }, {
        label: this.$t('common.date'),
        key: 'date',
        value: '',
        type: 'date',
      }],
    };
  },
  computed: {
    params() {
      const {
        sortBy, sortDesc, page, itemsPerPage,
      } = this.options;

      const params = this.filters.reduce((acc, it) => {
        if (it.value) {
          acc[it.key] = it.value;
        }
        return acc;
      }, {});

      if (itemsPerPage !== -1) {
        params.pageSize = itemsPerPage;
        params.page = page;
      }

      if (sortBy && sortBy.length) {
        params.sort = `${sortDesc[0] ? '-' : ''}${sortBy[0]}`;
      }

      return params;
    },
  },
  watch: {
    options: {
      handler() {
        this.getItems();
      },
      deep: true,
    },
  },
  created() {
    Array.from(Object.entries(this.$route.params)).forEach(([key, value]) => {
      if (value) {
        this.filters.find((it) => it.key === key).value = value;
      }
    });
    // this.getItems();
  },
  methods: {
    async getItems(filtered) {
      this.loading = true;

      if (filtered) {
        this.options.page = 1;
      }
      try {
        const { data = {} } = await this.$http.get('order-reports/nearest-shipment-by-parts', { params: this.params });

        this.headers = data.headers;
        this.items = data.items;
        this.total = data.total;
      } catch (err) {
        this.$http.mockApiError(err);
      } finally {
        this.loading = false;
      }
    },
    toggleFilters() {
      this.filtersShown = !this.filtersShown;
    },
  },
};
</script>
